!function(){"use strict";angular.module("scApp.empresas",["scApp.empresas.informes","scApp.empresas.anulaciones","scApp.empresas.adminusuarios"])}();